module.exports = __webpack_public_path__ + "img/SMT_43_Lai_Phui_Ching.9133628a.jpg";